import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { GoogleTagManagerService } from '@app/modules/core/services/analytics/google-tag-manager.service';
import { ACCEPTED_COOKIE } from '@shared/const/cookies.consts';

@UntilDestroy()
@Component({
  selector: 'bkg-cookies-advice',
  templateUrl: './cookies-advice.component.html',
})
export class CookiesAdviceComponent implements AfterViewInit {
  @Output() acceptReturn = new EventEmitter<void>();
  @Output() rejectReturn = new EventEmitter<void>();

  showCookie = false;

  constructor(
    private router: Router,
    private googleTagManagerService: GoogleTagManagerService
  ) {
    // eslint-disable-next-line @typescript-eslint/typedef
    router.events.pipe(untilDestroyed(this)).subscribe((val) => {
      const isResponsive = screen.width < 1000 ? true : false;
      if (val instanceof NavigationEnd && isResponsive) {
        if (
          val.url === '/services' ||
          val.url === '/traveler-data' ||
          val.url === '/confirmation'
        ) {
          this.showCookie = false;
        }
      }
    });
  }

  ngAfterViewInit(): void {
    if (!localStorage.getItem(ACCEPTED_COOKIE)) {
      this.showCookie = true;
    }
  }

  setAcceptedCookies(): void {
    localStorage.setItem(ACCEPTED_COOKIE, 'accept');
    this.acceptReturn.emit();
    this.showCookie = false;
    this.googleTagManagerService.consentGranted();
  }

  setRejectedCookies(): void {
    localStorage.setItem(ACCEPTED_COOKIE, 'reject');
    this.rejectReturn.emit();
    this.showCookie = false;
  }
}
